import { LoadingButton } from '@mui/lab';
import PropTypes from 'prop-types';
import Iconify from '../iconify';
import FileDropWrapper from '../DragAndDrop/FileDropWrapper';

FileUploadButton.propTypes = {
  handleFileDrop: PropTypes.func,
  text: PropTypes.string,
  accept: PropTypes.string,
  loading: PropTypes.bool
}

export default function FileUploadButton({ handleFileDrop, text = "Upload File", loading = false, accept = null })
{
  return <FileDropWrapper onFileDropped={handleFileDrop} accept={accept}>
    <LoadingButton
      loading={loading}
      variant="outlined"
      color="secondary"
      size="small"
      startIcon={<Iconify icon="material-symbols:upload" />}
    >
      {text}
    </LoadingButton>
  </FileDropWrapper>;
}
